<template>
	<div class="RadioButtons">
		<label class="container" v-for="option in options" :key="option.id">
			<input type="radio" :name="dataKey" :value="option.id" v-model="value" :id="option.id">
			<span class="checkmark"></span>
			{{option.label}}
		</label>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	name: 'RadioButtons',
	props: { options: Array, dataKey: String },
	data() {
		return {
			value: this.$store.state[this.dataKey],
		}
	},
	watch: {
		value() {
			this.setPartnerDataValue({ key: this.dataKey, value: this.value })
		},
		globalStateValue(newValue) {
			this.value = newValue
		},
	},
	computed: {
		globalStateValue() {
			return this.$store.state[this.dataKey]
		},
	},
	methods: {
		...mapActions(['setPartnerDataValue']),
	},
	components: {},
}
</script>

<style lang="stylus" scoped>
.RadioButtons {
	user-select: none;
	margin-top: 30px;
	margin-bottom: 20px;
}

/* The container */
.container {
    display: block;
    margin-right: 50px;
	position: relative;
	padding-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
	font-size: 16px;
	user-select: none;
	font-weight: 500;
}

/* Hide the browser's default radio button */
.container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
	position: absolute;
	top: 2px;
	left: 0;
	height: 15px;
	width: 15px;
	border: 2px solid gray;
	border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
	background-color: #f4f4f4;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
	border-color: #1bcbac;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
	content: '';
	position: absolute;
	display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
	display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
	top: 3px;
	left: 3px;
	width: 9px;
	height: 9px;
	border-radius: 50%;
	background: #1bcbac;
}
</style>
